import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mt-2"
  }, [!_vm.aberto ? _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm",
      "disabled": _vm.bloqueado
    },
    on: {
      "click": _vm.abrir
    }
  }, [_vm._v(" Corrigir dados fiscais: " + _vm._s(_vm.produto.descricao) + " ")]) : _c('div', {
    staticClass: "bg-light border rounded p-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.produto.descricao) + " — dados fiscais")]), _vm.carregando ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Carregando cadastro... ")], 1) : _vm.cadastro ? [_c('p', {
    staticClass: "text-muted small mt-2"
  }, [_vm._v(" A correção será salva no cadastro deste produto. ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Perfil tributário"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "descricao",
      "options": _vm.perfis,
      "filterable": false,
      "disabled": _vm.bloqueado || _vm.salvando,
      "placeholder": "Pesquisar perfil ou manter o atual"
    },
    on: {
      "search": _vm.pesquisarPerfil,
      "input": _vm.aplicarPerfil
    },
    model: {
      value: _vm.perfil,
      callback: function callback($$v) {
        _vm.perfil = $$v;
      },
      expression: "perfil"
    }
  })], 1)], 1), _vm._l(_vm.campos, function (campo) {
    return _c('b-col', {
      key: campo.chave,
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": campo.rotulo
      }
    }, [_c('VueSelect', {
      attrs: {
        "label": "codigo",
        "options": _vm.opcoes[campo.chave],
        "filterable": false,
        "disabled": _vm.bloqueado || _vm.salvando || _vm.herdadoDoPerfil(campo),
        "input-id": "fiscal-".concat(_vm._uid, "-").concat(campo.chave),
        "placeholder": "Pesquisar código"
      },
      on: {
        "search": function search(busca, loading) {
          return _vm.pesquisar(campo, busca, loading);
        },
        "open": function open($event) {
          _vm.pesquisar(campo, '', function () {});
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function fn(opcao) {
          return [_vm._v(_vm._s(opcao.codigo) + " — " + _vm._s(opcao.descricao))];
        }
      }, {
        key: "no-options",
        fn: function fn() {
          return [_vm._v("Nenhum código encontrado.")];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.form[campo.chave],
        callback: function callback($$v) {
          _vm.$set(_vm.form, campo.chave, $$v);
        },
        expression: "form[campo.chave]"
      }
    }), _vm.herdadoDoPerfil(campo) ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Definido pelo perfil tributário.")]) : _vm._e()], 1)], 1);
  })], 2), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('b-button', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "variant": "outline-primary",
      "size": "sm",
      "disabled": _vm.bloqueado || _vm.salvando
    },
    on: {
      "click": function click($event) {
        return _vm.salvar(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.salvando ? "Salvando..." : "Salvar correção") + " ")]), _c('b-button', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.bloqueado || _vm.salvando
    },
    on: {
      "click": function click($event) {
        return _vm.salvar(true);
      }
    }
  }, [_vm._v(" Salvar e reenviar esta pré-venda ")]), _c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "disabled": _vm.bloqueado || _vm.salvando
    },
    on: {
      "click": function click($event) {
        _vm.aberto = false;
      }
    }
  }, [_vm._v("Cancelar")])], 1)] : _vm._e(), _vm.erro ? _c('b-alert', {
    staticClass: "mt-2 mb-0",
    attrs: {
      "show": "",
      "variant": "danger",
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.erro))]) : _vm._e(), !_vm.cadastro && !_vm.carregando ? _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        _vm.aberto = false;
      }
    }
  }, [_vm._v("Fechar edição")]) : _vm._e(), _vm.salvo ? _c('p', {
    staticClass: "text-success mt-2 mb-0",
    attrs: {
      "role": "status"
    }
  }, [_vm._v(" Correção salva. A pré-venda pode ser reenviada. ")]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };